module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-contact container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.contact) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.contact.title) + "\n        ")]), _vm._v(" "), (_vm.contact.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact.content
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.contact1) ? _c('div', {
    staticClass: "column content content-sub",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [(_vm.contact1.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact1.content
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.contact2) ? _c('div', {
    staticClass: "column content content-sub",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [(_vm.contact2.content) ? _c('markdown', {
    attrs: {
      "source": _vm.contact2.content
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.note) ? _c('div', {
    staticClass: "columns is-gapless content",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [(_vm.note.content) ? _c('markdown', {
    attrs: {
      "source": _vm.note.content
    }
  }) : _vm._e()], 1)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c2debf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact.vue
// module id = 980
// module chunks = 1